// components/PDFPreviewModal.js
import { useState, useEffect } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import DownloadIcon from '@mui/icons-material/Download'

import toast from 'react-hot-toast'
import './PDFPreviewModal.css'

function PDFPreviewModal ({ source, onClose }) {
  const [pageNumber, setPageNumber] = useState(source.pageNumber || 1)
  const [pdfUrl, setPdfUrl] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // PDF URL von Firebase laden
    const loadPdfUrl = async () => {
      try {
        if (!source.filePath) {
          toast.error('PDF-Pfad nicht gefunden')
          return
        }

        const { getStorage, ref, getDownloadURL } = await import(
          'firebase/storage'
        )
        const { app } = await import('../firebase')

        const storage = getStorage(app)
        const pdfRef = ref(storage, source.filePath)
        const downloadURL = await getDownloadURL(pdfRef)

        setPdfUrl(downloadURL)
        setLoading(false)
      } catch (error) {
        console.error('PDF Load Error:', error)
        toast.error('Fehler beim Laden des PDFs: ' + error.message)
        setLoading(false)
      }
    }

    loadPdfUrl()
  }, [source.filePath])

  const handleDownload = () => {
    if (pdfUrl) {
      window.open(pdfUrl, '_blank')
      toast.success('PDF wird heruntergeladen')
    }
  }

  // Schließen bei ESC-Taste
  useEffect(() => {
    const handleEscape = e => {
      if (e.key === 'Escape') {
        onClose()
      }
    }

    document.addEventListener('keydown', handleEscape)
    return () => document.removeEventListener('keydown', handleEscape)
  }, [onClose])

  // Generiere iframe src mit page fragment
  const iframeSrc = pdfUrl ? `${pdfUrl}#page=${pageNumber}` : ''

  return (
    <div className='pdf-modal-overlay' onClick={onClose}>
      <div className='pdf-modal-content' onClick={e => e.stopPropagation()}>
        {/* Header mit Titel und Buttons */}
        <div className='pdf-modal-header'>
          <div className='pdf-modal-title'>
            <span className='pdf-filename'>{source.fileName}</span>
            {source.pageNumber && (
              <span className='pdf-page-info'>
                (Referenzierte Seite: {source.pageNumber})
              </span>
            )}
          </div>
          <div className='pdf-modal-actions'>
            <button
              className='pdf-action-btn'
              onClick={handleDownload}
              title='PDF herunterladen'
            >
              <DownloadIcon fontSize='small' />
              Download
            </button>
            <button
              className='pdf-close-btn'
              onClick={onClose}
              title='Schließen'
            >
              <CloseIcon fontSize='small' />
            </button>
          </div>
        </div>

        {/* PDF Viewer */}
        <div className='pdf-viewer-container'>
          {loading ? (
            <div className='pdf-loading'>
              <div className='spinner'></div>
              <p>PDF wird geladen...</p>
            </div>
          ) : pdfUrl ? (
            <>
              <iframe
                src={iframeSrc}
                className='pdf-iframe'
                title={source.fileName}
                onLoad={() => console.log('PDF loaded successfully')}
              />
            </>
          ) : (
            <div className='pdf-error'>PDF konnte nicht geladen werden</div>
          )}
        </div>
      </div>
    </div>
  )
}

export default PDFPreviewModal
